import API from '../api-service';

const baseUri = 'licensing';

export default {
  checkContentAccess(billingId, syncGuid) {
    return API.get(`${baseUri}/${billingId}/${syncGuid}`);
  },
};
